import React from 'react'

import Page from '../../../../components/pdf/Page'
import Header from './sections/Header'
import Content from './sections/Content'
import Footer from './sections/Footer'
import View from '../../../../components/pdf/View'
import Separator from '../../../../components/pdf/Separator'
import { COLORS } from '@btime/constants'

const PdfDocument = () => {
  return (
    <Page>
      <View style={{ padding: 10, borderRadius: 10, border: `1px solid ${COLORS.light3}` }}>
        <Header />
        <Content />
      </View>
      <Separator weight={5} />
      <Footer />
    </Page>
  )
}

export default PdfDocument
